export function addDelimiterToDate(yyyymmdd: string, delimiter = '年') {
    const year = yyyymmdd.slice(0, 4);
    const month = String(Number(yyyymmdd.slice(4, 6)));
    const day = String(Number(yyyymmdd.slice(6)));

    if (delimiter === '年') {
        return `${year}${delimiter}${month}月${day}日`;
    } else {
        return `${year}${delimiter}${month}${delimiter}${day}`;
    }
}

export function generateDateOptions() {
    const currentYear = new Date().getFullYear();
    const startYear = 1920;

    const years: string[] = [];
    for (let year = currentYear; year >= startYear; year--) {
        years.push(year.toString());
    }

    const months: string[] = Array.from({ length: 12 }, (_, i) => (i + 1).toString().padStart(2, '0'));
    const days: string[] = Array.from({ length: 31 }, (_, i) => (i + 1).toString().padStart(2, '0'));

    return {
        years,
        months,
        days,
    };
}

export function formatDateStringWithDelimiter(dateString: string, delimiter = '年') {
    const yyyymmdd = dateString.replace(/\//g, '');
    return addDelimiterToDate(yyyymmdd, delimiter);
}
